import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=f799d060"
import script from "./ImageWrapper.vue?vue&type=script&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports